import { LocaleCode } from "../../typings/lang";

export class TranslationsTextAreaController {
    public static $inject: string[] = ["$scope", "$translate"];

    // binded
    public rows: number;
    public cols: number;
    public model: any;
    public saveStandard: any;
    public saveTranslation: any;
    public disabled: boolean;
    public placeholderTextArea: any;
    public required: boolean;
    public onStandardKeyUp: Function;
    public onTranslationKeyUp: Function;
    public ariaLabelTextArea: string;
    public minLength: number;
    public maxLength: number;
    public name: string;
    public field: string;
    public translationField: string;
    public selectedLang: LocaleCode;
    public sourceLang: LocaleCode;

    public modelValue: any;
    public translationDisabled: boolean;

    constructor($scope) {
        $scope.$watch(
            () => this.selectedLang,
            (current, previous) => {
                if (this.model && (current || current !== previous)) {
                    $scope.modelValue = this.getTranslationField();
                    if (this.selectedLang === this.sourceLang) {
                        $scope.translationDisabled = false;
                    } else {
                        $scope.translationDisabled = !this.model?.[this.translationField]?.[this.selectedLang];
                    }
                }
            }
        );

        $scope.$watch(
            () => this.model,
            current => {
                if (current) {
                    $scope.modelValue = this.getTranslationField();
                    if (this.selectedLang === this.sourceLang) {
                        $scope.translationDisabled = false;
                    } else {
                        $scope.translationDisabled =
                            !this.model?.[this.translationField]?.[this.selectedLang];
                    }
                }
            }
        );

        // two way data binding workaround
        $scope.$watch(
            () => $scope.modelValue,
            current => {
                if (this.model) {
                    if (this.selectedLang === this.sourceLang) {
                        this.model[this.field] = current;
                    } else if (this.model?.[this.translationField]?.[this.selectedLang]) {
                        this.model[this.translationField][this.selectedLang] = current;
                    }
                }
            }
        );
    }

    public save() {
        if (this.selectedLang === this.sourceLang) {
            this.saveStandard();
        } else {
            this.saveTranslation();
        }
    }

    public keyUp() {
        if (this.selectedLang === this.sourceLang) {
            this.onStandardKeyUp?.();
        } else {
            this.onTranslationKeyUp?.();
        }
    }

    public getTranslationField() {
        if (this.selectedLang === this.sourceLang && !this.model?.[this.translationField]?.[this.selectedLang]) {
            return this.model[this.field];
        } else if (this.model?.[this.translationField]?.[this.selectedLang]) {
            return this.model[this.translationField][this.selectedLang];
        }
        return null;
    }
}
